import { IAnalyticsTransport } from "../interfaces";

export class NullTransport implements IAnalyticsTransport {
  public async logEvent(): Promise<void> {
    console.warn("Event is not logged. Transport is not provided");
  }
}
